import { render } from "./BusinessCardPreview.vue?vue&type=template&id=3db56c7e&scoped=true"
import script from "./BusinessCardPreview.vue?vue&type=script&lang=js"
export * from "./BusinessCardPreview.vue?vue&type=script&lang=js"

import "./BusinessCardPreview.vue?vue&type=style&index=0&id=3db56c7e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db56c7e"]])

export default __exports__